const hasInvalidItemQtd = (verifiedQtd, qtd, divergence) => {
  if (verifiedQtd > qtd) return true
  if (verifiedQtd < qtd && divergence === '') return true

  return false
}

const hasInvalidItemBatch = (batch, manufacturingDate, expirationDate, batchControl) => {
  if (batchControl === 'true') {
    return !(isBatchPresent(batch) && !!manufacturingDate && !!expirationDate)
  }

  // Sem controle de lote, o lote só é obrigatório quando há fabricação ou validade —
  // a mesma regra que a finalização da entrada aplica (StockMovementItem).
  return !isBatchPresent(batch) && (!!manufacturingDate || !!expirationDate)
}

const isBatchPresent = batch => {
  return (batch || '').trim().length > 0
}

export { hasInvalidItemQtd, hasInvalidItemBatch }
